import { ITeamDTO, ITeamSearchRequestDTO } from 'src/api/dtos';
import CommonRepository from 'src/api/repositories/common/common.repository';
import api from 'src/api/rtk/rtk-api';
import { IListQueryResult } from 'src/api/types';

export default class TeamsRepository extends CommonRepository {
  private static readonly baseRoute = '/teams';
  private static readonly apiURL = this.setBaseUrl(this.baseURL, this.baseRoute);

  public static endpoints = api.injectEndpoints({
    overrideExisting: true,
    endpoints: (build) => ({
      searchTeams: build.query<ITeamDTO[], ITeamSearchRequestDTO>({
        query: (params) => ({ url: `${this.apiURL}`, method: 'get', params }),
        transformResponse: (response: IListQueryResult<ITeamDTO>) => response.items,
      }),
    }),
  });
}
